import React from "react";
import {
  Grid,
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  ListItemAvatar,
  Avatar,
  makeStyles,
  Theme,
} from "@material-ui/core";
import Loader from "../../../../../components/LoaderSplash/Loader.component";
import {
  iconTypes,
  INSPECTION_NOTIFICATION,
} from "../../../../../constants/notifications.constant";
import { Link } from "react-router-dom";
import { ReactComponent as RightIcon } from "../../../../../assets/img/icon/Right.svg";
import SubHeader from "../../../../../components/Header/SubHeader.component";
import { useQuery } from "react-query";
import {
  selfInspectionsQuery,
  SELF_INSPECTIONS_QUERY,
  SELF_INSPECTIONS_QUERY_CONFIG,
} from "../../../../../query/selfInspections/selfInspections";

const useStyles = makeStyles((theme: Theme) => ({
  avatar: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    backgroundColor: theme.palette.secondary.main,
  },
}));

const PreviousInspections = () => {
  const { data: selfInspections, isLoading: loading } = useQuery(
    SELF_INSPECTIONS_QUERY,
    selfInspectionsQuery,
    SELF_INSPECTIONS_QUERY_CONFIG
  );

  const classes = useStyles();

  return (
    <>
      <Box display={loading ? "block" : "none"}>
        <Loader action={"Cargando inspecciones"}></Loader>
      </Box>
      <SubHeader
        content={
          <Typography variant="h6" color="primary">
            Inspecciones previas
          </Typography>
        }
      ></SubHeader>
      <Grid container justify="center" alignItems="center">
        <Grid item xs={11} sm={10} md={9} lg={8} xl={7}>
          <List>
            {selfInspections?.map((inspection: any) => (
              <ListItem
                divider
                key={inspection.id}
                component={Link}
                to={`/selfInspection/${inspection.id}`}
              >
                <ListItemAvatar>
                  <Avatar className={classes.avatar}>
                    <img
                      style={{ width: "60%" }}
                      src={iconTypes[INSPECTION_NOTIFICATION]}
                      alt={"inspection"}
                    ></img>
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Typography variant="subtitle2" color="primary">
                      Inspección#{inspection.id}
                    </Typography>
                  }
                  secondary={
                    <Typography variant="caption">
                      Vehículo[{inspection.vehicle.license_plate}]
                    </Typography>
                  }
                />

                <ListItemSecondaryAction>
                  <RightIcon></RightIcon>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        </Grid>
      </Grid>
    </>
  );
};

export default PreviousInspections;
